// Castintech dashboard — İşler (Paperclip yönlendirme) view modülü.
// Faz 52-Y W3b — iframe-in-SPA anti-pattern'i SON: Faz 46.F.2'nin 6-tab'lı
// Paperclip iframe embed'i kaldırıldı (çift chrome, 20s refresh/iframe-reload
// yamaları, sandbox bakımı). İşler view artık hafif bir yönlendirme kartı:
// Paperclip alt-bölümleri yeni sekmede native açılır. Custom dashboard'daki
// karşılıkları (Pano, Bugün, Ekip) zaten birincil menüde.
// Eski davranış gerekirse: git history Faz 46.F.2 — 47.0 (iframe + dirty-flag).

import { state } from '../state.js';
import { $, escAttr } from '../utils.js';

// Paperclip /CAS/* alt-bölümleri — native yeni-sekme hedefleri.
const PAPERCLIP_LINKS = [
  { label: '📊 Pano',     url: '/CAS/dashboard', desc: 'Paperclip ana panosu' },
  { label: '📥 Inbox',    url: '/CAS/inbox',     desc: 'Gelen kutusu' },
  { label: '🎫 Issues',   url: '/CAS/issues',    desc: 'Tüm işler (filtre/arama)' },
  { label: '🤖 Agents',   url: '/CAS/agents',    desc: 'Ajan listesi ve durumları' },
  { label: '🎯 Goals',    url: '/CAS/goals',     desc: 'Hedefler' },
  { label: '🔁 Routines', url: '/CAS/routines',  desc: 'Rutinler (zamanlanmış işler)' },
];

export function loadIsler(): void {
  if (state.currentPage === 'isler') renderIsler();
}

export function renderIsler(): void {
  const container = $('view-isler');
  if (!container) return;

  const subEl = $('isler-sub');
  if (subEl) subEl.textContent = 'Paperclip native UI · yeni sekmede açılır';

  const body = $('isler-body');
  if (!body) return;

  // İçerik statik — 20s periodic render()'da innerHTML'i yeniden yazma
  // (hover/focus state korunur; Faz 47.0 dirty-flag deseninin sadeleşmiş hali).
  if (body.querySelector('.isler-links-card')) return;

  body.innerHTML = `
    <div class="isler-links-card">
      <p class="isler-links-intro">
        Paperclip artık kendi sekmesinde native açılır — iframe içinde iframe
        karmaşası bitti. Gündelik özet için <strong>🎯 Bugün</strong> ve
        <strong>📋 Pano</strong> bu dashboard'da; derin işlem (issue düzenleme,
        rutin yönetimi) için aşağıdan Paperclip'e geç.
      </p>
      <div class="isler-links-grid">
        ${PAPERCLIP_LINKS.map(
          (l) => `
          <a class="isler-link-item" href="${escAttr(l.url)}" target="_blank" rel="noopener">
            <span class="isler-link-label">${l.label} ↗</span>
            <span class="isler-link-desc">${l.desc}</span>
          </a>
        `
        ).join('')}
      </div>
    </div>
  `;
}
